export default __webpack_public_path__ + "static/media/vaccine.9d59427d.svg";